import type {
  AgentGetAgentTradePerformanceChartParams,
  AgentGetPortfolioChartInput,
  AgentGetWalletPortfolioChartInput,
} from '../api'
import { useQuery } from '@tanstack/react-query'
import {
  agentPortfolioOptions,
  agentPortfolioChartOptions,
  agentTradePerformanceOptions,
  agentTradePerformanceChartOptions,
  agentWalletPortfolioChartOptions,
} from './agent-portfolio.options'

export const useAgentPortfolio = () => {
  return useQuery(agentPortfolioOptions())
}

export const useAgentPortfolioChart = (params: AgentGetPortfolioChartInput) => {
  return useQuery(agentPortfolioChartOptions(params))
}

export const useAgentTradePerformance = () => {
  return useQuery(agentTradePerformanceOptions())
}

export const useAgentTradePerformanceChart = (
  params: AgentGetAgentTradePerformanceChartParams,
) => {
  return useQuery(agentTradePerformanceChartOptions(params))
}
export const useAgentWalletPortfolioChart = (
  params: AgentGetWalletPortfolioChartInput,
) => {
  return useQuery(agentWalletPortfolioChartOptions(params))
}
